import config from "../config/config";
import axios from "../util/axios";
import type {
  SendNotificationDto,
  BroadcastNotificationDto,
  SendNotificationResponse,
  BroadcastNotificationResponse,
} from "../types/notifications";

// Send notification to a specific user
export async function sendNotificationToUser(
  params: SendNotificationDto,
): Promise<{ data: SendNotificationResponse }> {
  return axios.post(
    `${config.defaults.api_url}/push-notifications/send`,
    params,
  );
}

// Broadcast notification to all users
export async function broadcastNotification(
  params: BroadcastNotificationDto,
): Promise<{ data: BroadcastNotificationResponse }> {
  return axios.post(
    `${config.defaults.api_url}/push-notifications/broadcast`,
    params,
  );
}
